export default __webpack_public_path__ + "static/media/homeabout2.341c3cf3.jpg";